import { collection, doc, onSnapshot } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { SecureStorage } from "./SecureStorage";
import { firestoreDB, storage } from "../firebase";

console.log("WARNING: MAKE SURE THIS IS LOADED ONLY ONCE!")

const secureStorage = new SecureStorage("PageParrot-AIzaSyC5ioopy0fIUzfl5nUIjt1t77wLnFqS2dM");

function getIdentifiers() {
    return {
        channel: getChannel(),
        workspace: getWorkspace(),
    };
}

const getWorkspaceType = () => 0;

const getWorkspace = () => "T03174J6D3K";

const getChannel = () => "C07GJRYKX5K";

const getThreadCollection = () => "Threads-Slack";

async function getPrevSessionLocation() {
    const prevLocationString = await secureStorage.getItem("JPLocation");
    if (!prevLocationString) {
        return null;
    }
    const prevLocation = JSON.parse(prevLocationString);
    if (!prevLocation.location || !prevLocation.createdAtLocal || new Date(prevLocation.createdAtLocal).getTime() < new Date().getTime() - 1000 * 60 * 30) {
        return null;
    }
    return prevLocation.location;
}

function getPrevSessionThreadId() {
    //return null;//JPChatSession;
    const threadIdString = localStorage.getItem("JPChatSession" + getChannel() + getWorkspace());
    if (!threadIdString) {
        return null;
    }
    const prevThreadSession = JSON.parse(threadIdString);
    if (!prevThreadSession.threadId || !prevThreadSession.createdAtLocal || new Date(prevThreadSession.createdAtLocal).getTime() < new Date().getTime() - 1000 * 60 * 60 * 24) {
        return null;
    }
    return prevThreadSession.threadId;
}

function getPrevSessionMessages() {
    //return null;//JPSessionMessages;
    const prevSessionMessagesString = localStorage.getItem('JPSessionMessages' + getChannel() + getWorkspace());
    if (!prevSessionMessagesString) {
        return {
            messages: [],
            latestSeenThreadIndex: null,
        };
    }
    const prevSessionMessages = JSON.parse(prevSessionMessagesString);
    if (!prevSessionMessages.payload || !prevSessionMessages.createdAtLocal || new Date(prevSessionMessages.createdAtLocal).getTime() < new Date().getTime() - 1000 * 60 * 60 * 24) {
        return {
            messages: [],
            latestSeenThreadIndex: null,
        };
    }
    return {
        messages: prevSessionMessages?.payload?.messages ? prevSessionMessages.payload.messages : [],
        latestSeenThreadIndex: prevSessionMessages?.payload?.latestSeenThreadIndex ? prevSessionMessages.payload.latestSeenThreadIndex : null,
    };
}

function setPrevSessionMessages(messages, latestSeenThreadIndex = null) {
    localStorage.setItem('JPSessionMessages' + getChannel() + getWorkspace(), JSON.stringify({
        payload: {
            messages,
            latestSeenThreadIndex,
        },
        createdAtLocal: new Date(),
    }));
}

function setPrevSessionThreadId(threadId) {
    localStorage.setItem("JPChatSession" + getChannel() + getWorkspace(), JSON.stringify({
        threadId,
        createdAtLocal: new Date(),
    }));
}

async function setPrevSessionLocation(location) {
    await secureStorage.setItem("JPLocation", JSON.stringify({
        location,
        createdAtLocal: new Date(),
    }));
}

function getDocRef(threadId) {
    console.log("threadId:", threadId);
    return doc(firestoreDB, getThreadCollection(), threadId);
}

function getNewDocRef() {
    return doc(collection(firestoreDB, getThreadCollection()));
}

/**function getId() {
    try {
        //if (localStorage.getItem("JPChatSession + window.PageParrot.config.slackChannel + window.PageParrot.config.workspace"))
        //  return localStorage.getItem("JPChatSession + window.PageParrot.config.slackChannel + window.PageParrot.config.workspace");
        //const item = doc(collection(db, "Threads")).id;
        //localStorage.setItem("JPChatSession + window.PageParrot.config.slackChannel + window.PageParrot.config.workspace", item);
        //console.log(item)
        return "tUKYTyPXfGmCow7UbIoi";//item
        //return doc(collection(db, "Threads")).id;
    } 
    catch (e) {
        console.error("Error: ", e);
    }
    return null;
}*/

//const threadDocRef = doc(db, "Threads", getId());

/**function useThread() {
    return useDocumentData(threadDocRef);
}*/

async function uploadFile(file) {
    console.log("Uploading file: " + file.path);
    console.log(JSON.stringify(file));
    const storageRef = ref(storage, `VisitorUploads/${getWorkspace()}/${file.name}`);
    //const fileRef = storageRef.child(file.name);
    //await fileRef.put(file.content, { contentType: file.type });
    //return fileRef;
    console.log("Uploading file: " + file.name);
    console.log("File type: " + file.type);
    const metadata = {
        contentType: 'application/octet-stream', // Forces download behavior
        contentDisposition: `attachment; filename="${file.name}"`,
        customMetadata: {
            'Content-Disposition': `attachment; filename="${file.name}"`,
            'content-type': 'application/octet-stream'
        }
    };

    const uploadTask = uploadBytesResumable(storageRef, file, metadata);
    return new Promise((resolve, reject) => {
        uploadTask.on(
            'state_changed',
            (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
                switch (snapshot.state) {
                    case 'paused':
                        console.log('Upload is paused');
                        break;
                    case 'running':
                        console.log('Upload is running');
                        break;
                    default:
                        console.log('Upload is in an unknown state');
                }
            },
            (error) => {
                console.error(error.code, error.message);
                reject(error);
            },
            () => {
                getDownloadURL(uploadTask.snapshot.ref)
                    .then((downloadURL) => {
                        console.log('File available at', downloadURL);
                        resolve(downloadURL);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            }
        );
    });
}

let isListening = false;

function setSnapshotListener(docRef, setThreadData, setThreadLoading) {
    try {
        if (isListening || !docRef.current) {
            console.log("WARNING: Already listening for changes...");
            return;
        }
        console.log("WARNING: Listening for changes...");
        isListening = true;
        const unsubscribe = onSnapshot(docRef.current, (snapshot) => {
            console.log("RENDER: onSnapshot");
            if (snapshot.exists()) {
                setThreadData(snapshot.data());
            } else {
                if (unsubscribe) {
                    unsubscribe();
                }
                setPrevSessionThreadId(null);
                setThreadData(null);
                isListening = false;
                docRef.current = null;
            }
            if (setThreadLoading) {
                setThreadLoading(false);
            }
        });
    } catch (error) {
        console.error("Error Snapshot Listener: ", error);
    }
}

const url = "https://cluster.pageparrot.com";

export { 
    uploadFile, 
    getPrevSessionThreadId, 
    getDocRef, 
    getNewDocRef, 
    getPrevSessionMessages, 
    getIdentifiers,
    setPrevSessionMessages,
    setPrevSessionThreadId,
    getPrevSessionLocation,
    setPrevSessionLocation,
    url,
    getWorkspaceType,
    getWorkspace,
    getChannel,
    setSnapshotListener,
};
